// assets
import {
  IconDashboard,
  IconSitemap,
  IconArticle,
  IconCoin,
  IconAdjustments,
  IconKey,
  IconGardenCart,
  IconUser,
  IconUserScan,
  IconMessages,
  IconReportMoney,
  IconRobot,
  IconBellRinging,
  IconActivity,
  IconBook,
  IconPlayerPlay,
  IconLicense,
  IconDatabase,
  IconMovie,
  IconRocket,
  IconWallet,
  IconTrendingUp,
  IconChartPie,
  IconUsers
} from '@tabler/icons-react';

// constant
const icons = {
  IconDashboard,
  IconSitemap,
  IconArticle,
  IconCoin,
  IconAdjustments,
  IconKey,
  IconGardenCart,
  IconUser,
  IconUserScan,
  IconMessages,
  IconReportMoney,
  IconRobot,
  IconBellRinging,
  IconActivity,
  IconBook,
  IconPlayerPlay,
  IconLicense,
  IconDatabase,
  IconMovie,
  IconRocket,
  IconWallet,
  IconTrendingUp,
  IconChartPie,
  IconUsers
};

// ==============================|| 用户侧（人人可见，按「接入 → 财务 → 账号」分组） ||============================== //

const access = {
  id: 'access',
  title: '接入',
  type: 'group',
  children: [
    { id: 'guide', title: '开始使用', type: 'item', url: '/panel/guide', icon: icons.IconRocket, breadcrumbs: false },
    { id: 'token', title: 'API 密钥', type: 'item', url: '/panel/token', icon: icons.IconKey, breadcrumbs: false },
    { id: 'models', title: '可用模型', type: 'item', url: '/panel/models', icon: icons.IconRobot, breadcrumbs: false },
    { id: 'playground', title: '试用台', type: 'item', url: '/panel/playground', icon: icons.IconPlayerPlay, breadcrumbs: false }
  ]
};

const finance = {
  id: 'finance',
  title: '财务',
  type: 'group',
  children: [
    { id: 'topup', title: '余额与充值', type: 'item', url: '/panel/topup', icon: icons.IconWallet, breadcrumbs: false },
    { id: 'plan', title: 'Token Plan', type: 'item', url: '/panel/plan', icon: icons.IconLicense, breadcrumbs: false },
    { id: 'usage-page', title: '用量与账单', type: 'item', url: '/panel/usage', icon: icons.IconDashboard, breadcrumbs: false },
    { id: 'ledger', title: '充值记录', type: 'item', url: '/panel/ledger', icon: icons.IconCoin, breadcrumbs: false }
    // 异步任务保留路由，由相关业务深链进入。
  ]
};

const account = {
  id: 'account',
  title: '账号',
  type: 'group',
  children: [
    { id: 'invite', title: '推广与收益', type: 'item', url: '/panel/invite', icon: icons.IconUsers, breadcrumbs: false },
    { id: 'profile', title: '账户设置', type: 'item', url: '/panel/profile', icon: icons.IconUserScan, breadcrumbs: false }
  ]
};

// ==============================|| 管理（仅管理员；普通用户看不到本组） ||============================== //

const manage = {
  id: 'manage',
  title: '运营管理',
  type: 'group',
  children: [
    { id: 'promoter', title: '推广提现', type: 'item', url: '/panel/promoter', icon: icons.IconUsers, breadcrumbs: false, isAdmin: true },
    { id: 'orders', title: '支付订单', type: 'item', url: '/panel/orders', icon: icons.IconReportMoney, breadcrumbs: false, isAdmin: true },
    {
      id: 'channel',
      title: '渠道',
      type: 'item',
      url: '/panel/channel',
      icon: icons.IconSitemap,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'channelpool',
      title: '渠道池',
      type: 'item',
      url: '/panel/channel_pool',
      icon: icons.IconActivity,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'model-catalog',
      title: '模型目录',
      type: 'item',
      url: '/panel/model_catalog',
      icon: icons.IconDatabase,
      breadcrumbs: false,
      isAdmin: true,
      isRoot: true
    },
    {
      id: 'user',
      title: '用户',
      type: 'item',
      url: '/panel/user',
      icon: icons.IconUser,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'revenue',
      title: '营收看板',
      type: 'item',
      url: '/panel/revenue',
      icon: icons.IconTrendingUp,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'profit',
      title: '毛利看板',
      type: 'item',
      url: '/panel/profit',
      icon: icons.IconChartPie,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'billing-review',
      title: '异常账务核对',
      type: 'item',
      url: '/panel/billing_review',
      icon: icons.IconReportMoney,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'reconciliation',
      title: '成本对账',
      type: 'item',
      url: '/panel/reconciliation',
      icon: icons.IconReportMoney,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'alert',
      title: '告警配置',
      type: 'item',
      url: '/panel/alert',
      icon: icons.IconBellRinging,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'subscription',
      title: 'Token Plan 管理',
      type: 'item',
      url: '/panel/subscription',
      icon: icons.IconLicense,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'redemption',
      title: '兑换',
      type: 'item',
      url: '/panel/redemption',
      icon: icons.IconCoin,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'setting',
      title: '设置',
      type: 'item',
      url: '/panel/setting',
      icon: icons.IconAdjustments,
      breadcrumbs: false,
      isAdmin: true
    }
  ]
};

const panelGroups = [access, finance, account, manage];

export default panelGroups;
